import useSinglePart from "../../data/useSinglePart";
import LoadingPulse from "../shared/LoadingPulse";

export default function EstimatedListingTitle({partId}: {partId: string}) {
  const { estimatedTitle } = useSinglePart(partId);

  if (estimatedTitle.isLoading) {
    return <LoadingPulse height="h-5" width="w-20" />;
  }

  if (estimatedTitle.isError || estimatedTitle.data?.success === false) {
    return <span className="text-red-400">Error loading title</span>;
  }

  return <span>{estimatedTitle.data?.data}</span>;
}